// 메뉴 vuex
const clientStore = {
  namespaced: true,

  state: {
    client: {},
    newClient: {},
    tab: null,
    invoice: {},
    salesReport: {}
  },

  getters: {
    getClient: state => state.client,
    getNewClient: state => state.newClient,
    getTab: state => state.tab,
    getInvoice: state => state.invoice,
    getSalesReport: state => state.salesReport
  },

  mutations: {
    mutationClient: (state, payload) => {
      state.client = payload
    },

    mutationNewClient: (state, payload) => {
      state.newClient = payload
    },

    mutationTab: (state, payload) => {
      state.tab = payload
    },

    mutationInvoice: (state, payload) => {
      state.invoice = payload
    },

    mutationSalesReport: (state, payload) => {
      state.salesReport = payload
    }
  }
}

export default clientStore
